var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 48 48",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 2c-12.1308594 0-22 9.8691406-22 22s9.8691406 22 22 22 22-9.8691406 22-22-9.8691406-22-22-22z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ccc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 2c-12.1308594 0-22 9.8691406-22 22s9.8691406 22 22 22 22-9.8691406 22-22-9.8691406-22-22-22zm0 40c-9.925293 0-18-8.0751953-18-18 0-9.925293 8.074707-18 18-18s18 8.074707 18 18c0 9.9248047-8.074707 18-18 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.4853516 29.6572266c.78125.78125.78125 2.046875 0 2.828125-.3901367.390625-.9023438.5859375-1.4140625.5859375s-1.0239258-.1953125-1.4140625-.5859375l-5.6572266-5.6572266-5.6572266 5.6572266c-.3901367.390625-.9023438.5859375-1.4140625.5859375s-1.0239258-.1953125-1.4140625-.5859375c-.78125-.78125-.78125-2.046875 0-2.828125l5.6572266-5.6572266-5.6572266-5.6572266c-.78125-.7807617-.78125-2.0473633 0-2.828125.7802734-.78125 2.0478516-.78125 2.828125 0l5.6572266 5.6572266 5.6572266-5.6572266c.7802734-.78125 2.0478516-.78125 2.828125 0 .78125.7807617.78125 2.0473633 0 2.828125l-5.6572266 5.6572266z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.cb81f19734a5866305d1e3b944cb598a.svg";
export { ForwardRef as ReactComponent };